import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'lil-gui'
import * as CANNON from 'cannon-es'
import gsap from 'gsap' 

/**
 * Debug
 */
// Add debug panel
const gui = new dat.GUI({width:70})
// Add debug objects for parameters and buttons
const debugObject = {}
// Add counter
var heightCounter = 3
// Add box buttons:

// Steak
debugObject.createSteak = () => 
{
    const SteakHeight = 0.3
    createSteak
    (
        0.6   + Math.random() * 0.1, // radius 
        SteakHeight,               // height
        {
            x: (Math.random() - 0.5) * 0.1 ,
            y: 3,
            z: (Math.random() - 0.5) * 0.1
        }
    )
    heightCounter += SteakHeight
}
gui.add(debugObject, 'createSteak').name('Steak')

// Cheese
debugObject.createCheese = () => 
{
    const cheeseHeight = 0.05
    createCheese
    (
        1   + Math.random() * 0.1, // width, 
        cheeseHeight,                      // height, 
        1   + Math.random() * 0.1, // depth
        {
            x: (Math.random() - 0.5) * 0.1 ,
            y: 3,
            z: (Math.random() - 0.5) * 0.1
        }
    )
    heightCounter += cheeseHeight
}
gui.add(debugObject, 'createCheese').name('Cheese')

// Tomatos
debugObject.createTomato = () => 
{
    const tomatoHeight = 0.05
    createTomato
    (
        0.2   + Math.random() * 0.1, // radius 
        tomatoHeight,               // height
        {
            x: (Math.random() - 0.5) * 1 ,
            y: 3,
            z: (Math.random() - 0.5) * 1
        }
    )
    heightCounter += tomatoHeight
}
gui.add(debugObject, 'createTomato').name('Tomatos')

// Pickles
debugObject.createPickles = () => 
{
    const pickleHeight = 0.05
    createPickles
    (
        0.2   + Math.random() * 0.1, // radius 
        pickleHeight,               // height
        {
            x: (Math.random() - 0.5) * 1 ,
            y: 3,
            z: (Math.random() - 0.5) * 1
        }
    )
    heightCounter += pickleHeight
}
gui.add(debugObject, 'createPickles').name('Pickles')

// Salt
debugObject.createSalt = () => 
{
    const saltHeight = 0.05
    createSalt
    (
        saltHeight + Math.random() * 0.01, // width
        saltHeight + Math.random() * 0.01, // height
        saltHeight + Math.random() * 0.01, // depth
        {
            x: (Math.random() - 0.5) * 1 ,
            y: 3,
            z: (Math.random() - 0.5) * 1
        }
    )
    heightCounter += saltHeight
}
gui.add(debugObject, 'createSalt').name('Salt')

// Pepper
debugObject.createSphere = () => 
{
    createSphere
    (
        0.05 + Math.random() * 0.01, // random radius
        {
            x: (Math.random() - 0.5) * 1 ,
            y:3,
            z: (Math.random() - 0.5) * 1
        }
    )
}
gui.add(debugObject, 'createSphere').name('Pepper')

// Bread
debugObject.createBread = () => 
{
    const BreadHeight = 0.3
    createBread
    (
        0.6   + Math.random() * 0.1, // radius 
        BreadHeight,                 // height
        {
            x: (Math.random() - 0.5) * 0.1 ,
            y: 3,
            z: (Math.random() - 0.5) * 0.1
        }
    )
    heightCounter += BreadHeight
}
gui.add(debugObject, 'createBread').name('Bread')

// add Reset button
debugObject.reset = () =>
{
    for(const object of objectsToUpdate)
    {
        // remove body
        object.body.removeEventListener('collide', playHitSound)
        world.removeBody(object.body)

        // remove mesh
        scene.remove(object.mesh)
    }
    objectsToUpdate.splice(0, objectsToUpdate.length)
}
gui.add(debugObject, 'reset')

/**
 * Base
 */
// Canvas
const canvas = document.querySelector('canvas.webgl')

// Scene
const scene = new THREE.Scene()

/** 
 * Sounds
 */
const hitSound = new Audio('/sounds/punch.mp3')
const playHitSound = (collision) =>
{
    const impactStrenght = collision.contact.getImpactVelocityAlongNormal()
    if (impactStrenght > 5) // add function to filter only sounds of a strong impact
    {
        hitSound.volume = 1 - 1 / impactStrenght
        if (hitSound.currentTime  > 0.1)
        {
            hitSound.currentTime = 0 // reset timebar after each collision
        }
        
        hitSound.play()
        
    }
    
}

/**
 * Textures
 */
const textureLoader = new THREE.TextureLoader()
const cubeTextureLoader = new THREE.CubeTextureLoader()

const environmentMapTexture = cubeTextureLoader.load([
    '/textures/environmentMaps/0/px.png',
    '/textures/environmentMaps/0/nx.png',
    '/textures/environmentMaps/0/py.png',
    '/textures/environmentMaps/0/ny.png',
    '/textures/environmentMaps/0/pz.png',
    '/textures/environmentMaps/0/nz.png'
])

/**
 * Physics
 */
// World
const world = new CANNON.World()
world.broadphase = new CANNON.SAPBroadphase(world)  // optimization number 1
world.allowSleep = true                             // optimization number 2
world.gravity.set(0, -9.82, 0)

// Materials
const defaultMaterial = new CANNON.Material('default')

const defaultContactMaterial = new CANNON.ContactMaterial(
    defaultMaterial,
    defaultMaterial,
    {
        friction: 0.01,
        restitution: 0.3
    }
)
world.addContactMaterial(defaultContactMaterial)
world.defaultContactMaterial = defaultContactMaterial

// Floor
const floorShape = new CANNON.Plane()
const floorBody = new CANNON.Body()
        floorBody.mass = 0
        floorBody.addShape(floorShape)
        floorBody.quaternion.setFromAxisAngle(
            new CANNON.Vec3( -1, 0, 0 ),        // rotate around -x axis
            Math.PI / 2                         // rotation angle
        )
world.addBody(floorBody)

/**
 * Floor
 */
const floor = new THREE.Mesh(
    new THREE.PlaneGeometry(10, 10),
    new THREE.MeshStandardMaterial({
        color: '#262837',
        metalness: 0,
        roughness: 1,
        envMap: environmentMapTexture,
        envMapIntensity: 0.5
    })
)
floor.receiveShadow = true
floor.rotation.x = - Math.PI * 0.5
// scene.add(floor)

/**
 * Lights
 */
const ambientLight = new THREE.AmbientLight(0xffffff, 0.5)
scene.add(ambientLight)

const directionalLight = new THREE.DirectionalLight(0xffffff, 0.2)
directionalLight.castShadow = true
directionalLight.shadow.mapSize.set(1024, 1024)
directionalLight.shadow.camera.far = 15
directionalLight.shadow.camera.left = - 7
directionalLight.shadow.camera.top = 7
directionalLight.shadow.camera.right = 7
directionalLight.shadow.camera.bottom = - 7
directionalLight.position.set(5, 5, 5)
scene.add(directionalLight)

/**
 * Sizes
 */
const sizes = {
    width: window.innerWidth,
    height: window.innerHeight
}

window.addEventListener('resize', () =>
{
    // Update sizes
    sizes.width = window.innerWidth
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 0.1, 100)
camera.position.set(- heightCounter, heightCounter, heightCounter)
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.enableDamping = true

/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({ canvas: canvas, alpha:  true })
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))

/**
 * Utils
 */

// Create an empty array for objects
const objectsToUpdate = []

// Create Geometries
const boxGeometry = new THREE.BoxGeometry(1,1,1)
const sphereGeometry = new THREE.SphereGeometry(1, 20, 20)
const cylinderGeometry = new THREE.CylinderGeometry(1, 1, 1, 16)

// Create materials
const material = new THREE.MeshStandardMaterial({
    metalness: 0.3,
    roughness: 0.4,
    envMap: environmentMapTexture
})
const breadMaterial = new THREE.MeshStandardMaterial({
    metalness: 0.3,
    roughness: 0.4,
    color: '#FFDE5E',
    envMap: environmentMapTexture
})
// gui.addColor(breadMaterial, 'color').name('Bread Color')
const meatMaterial = new THREE.MeshStandardMaterial({
    metalness: 0.3,
    roughness: 0.4,
    color: '#681f12',
    envMap: environmentMapTexture
})
// gui.addColor(meatMaterial, 'color').name('Steak Color')

const cheeseMaterial = new THREE.MeshStandardMaterial({
    metalness: 0.3,
    roughness: 0.4,
    color: '#FFDC00',
    envMap: environmentMapTexture
})
// gui.addColor(cheeseMaterial, 'color').name('Cheese Color')

const tomatoMaterial = new THREE.MeshStandardMaterial({
    metalness: 0.3,
    roughness: 0.4,
    color: '#f01919',
    envMap: environmentMapTexture
})
// gui.addColor(tomatoMaterial, 'color').name('Tomato Color')

const pickleMaterial = new THREE.MeshStandardMaterial({
    metalness: 0.3,
    roughness: 0.4,
    color: '#68cc3e',
    envMap: environmentMapTexture
})
// gui.addColor(pickleMaterial, 'color').name('Pickle Color')

const pepperMaterial = new THREE.MeshStandardMaterial({
    metalness: 0.3,
    roughness: 0.4,
    color: '#21201c',
    envMap: environmentMapTexture
})
// gui.addColor(pepperMaterial, 'color').name('Pepper Color')


/**
 * Bread
 */
const createBread = (radius, height, position) =>
{
    // Three.js Mesh
    const mesh = new THREE.Mesh( cylinderGeometry, breadMaterial )
    mesh.scale.set( radius, height, radius )
    mesh.castShadow = true
    mesh.receiveShadow = true
    mesh.position.copy(position)
    scene.add(mesh)

    // Cannon.js body
    const shape = new CANNON.Cylinder(radius, radius, height, 16)
    const body =  new CANNON.Body({
        mass:       1, 
        shape:      shape,
        material:   defaultMaterial
    })
    body.position.copy(position)
    body.addEventListener('collide', playHitSound )
    world.addBody(body)
    
    // Save in objects to update
    objectsToUpdate.push({
        mesh: mesh,
        body: body
    })
}
createBread( 0.7, 0.3, { x:0, y:4, z:0.1 })

/**
 * Steak
 */
const createSteak = (radius, height, position) =>
{
    // Three.js Mesh
    const mesh = new THREE.Mesh( cylinderGeometry, meatMaterial )
    mesh.scale.set( radius, height, radius )
    mesh.castShadow = true
    mesh.receiveShadow = true
    mesh.position.copy(position)
    scene.add(mesh)

    // Cannon.js body
    const shape = new CANNON.Cylinder(radius, radius, height, 16)
    const body =  new CANNON.Body({
        mass:       1, 
        shape:      shape,
        material:   defaultMaterial
    })
    body.position.copy(position)
    body.addEventListener('collide', playHitSound )
    world.addBody(body)
    
    // Save in objects to update
    objectsToUpdate.push({
        mesh: mesh,
        body: body
    })
}
// createSteak( 1, 0.3, { x:0, y:4, z:0.1 })


/**
 * Cheese
 */
const createCheese = (width, height, depth, position) =>
{
    // Three.js Mesh
    const mesh = new THREE.Mesh( boxGeometry, cheeseMaterial )
    mesh.scale.set( width, height, depth )
    mesh.castShadow = true
    mesh.receiveShadow = true
    mesh.position.copy(position)
    scene.add(mesh)

    // Cannon.js body
    const shape = new CANNON.Box(new CANNON.Vec3(width/2, height/2, depth/2))
    const body =  new CANNON.Body({
        mass:       1, 
        shape:      shape,
        material:   defaultMaterial
    })
    body.position.copy(position)
    body.addEventListener('collide', playHitSound )
    world.addBody(body)
    
    // Save in objects to update
    objectsToUpdate.push({
        mesh: mesh,
        body: body
    })
}
// createCheese( Math.random(), Math.random(), Math.random(), { x:0, y:4, z:0.1 })

/**
 * Tomato
 */
const createTomato = (radius, height, position) =>
{
    // Three.js Mesh
    const mesh = new THREE.Mesh( cylinderGeometry, tomatoMaterial )
    mesh.scale.set( radius, height, radius )
    mesh.castShadow = true
    mesh.receiveShadow = true
    mesh.position.copy(position)
    scene.add(mesh)

    // Cannon.js body
    const shape = new CANNON.Cylinder(radius, radius, height, 16)
    const body =  new CANNON.Body({
        mass:       1, 
        shape:      shape,
        material:   defaultMaterial
    })
    body.position.copy(position)
    body.addEventListener('collide', playHitSound )
    world.addBody(body)
    
    // Save in objects to update
    objectsToUpdate.push({
        mesh: mesh,
        body: body
    })
}

/**
 * Pickles
 */
const createPickles = (radius, height, position) =>
{
    // Three.js Mesh
    const mesh = new THREE.Mesh( cylinderGeometry, pickleMaterial )
    mesh.scale.set( radius, height, radius )
    mesh.castShadow = true
    mesh.receiveShadow = true
    mesh.position.copy(position)
    scene.add(mesh)

    // Cannon.js body
    const shape = new CANNON.Cylinder(radius, radius, height, 16)
    const body =  new CANNON.Body({
        mass:       1, 
        shape:      shape,
        material:   defaultMaterial
    })
    body.position.copy(position)
    body.addEventListener('collide', playHitSound )
    world.addBody(body)
    
    // Save in objects to update
    objectsToUpdate.push({
        mesh: mesh,
        body: body
    })
}

/**
 * Salt
 */
const createSalt = (width, height, depth, position) =>
{
    // Three.js Mesh
    const mesh = new THREE.Mesh( boxGeometry, material )
    mesh.scale.set( width, height, depth )
    mesh.castShadow = true
    mesh.receiveShadow = true
    mesh.position.copy(position)
    scene.add(mesh)

    // Cannon.js body
    const shape = new CANNON.Box(new CANNON.Vec3(width/2, height/2, depth/2))
    const body =  new CANNON.Body({
        mass:       1, 
        shape:      shape,
        material:   defaultMaterial
    })
    body.position.copy(position)
    body.addEventListener('collide', playHitSound )
    world.addBody(body)
    
    // Save in objects to update
    objectsToUpdate.push({
        mesh: mesh,
        body: body
    })
}

/**
 * Pepper
 */
const createSphere = (radius, position) =>
{
    // Three.js Mesh
    const mesh = new THREE.Mesh( sphereGeometry, pepperMaterial )
    mesh.scale.set(radius, radius, radius)
    mesh.castShadow = true
    mesh.position.copy(position)
    scene.add(mesh)

    // Cannon.js body
    const shape = new CANNON.Sphere(radius)
    const body = new CANNON.Body({
        mass: 1,
        position: new CANNON.Vec3(0,3,0),
        shape: shape,
        material: defaultMaterial
    })
    body.position.copy(position)
    body.addEventListener('collide', playHitSound )
    world.addBody(body)

    // Save in objects to update
    objectsToUpdate.push({
        mesh: mesh,
        body: body
    })
}
// createSphere(0.5, {x:0,y:3,z:0})

/**
 * Background
 */
for(let i=0; i<1000; i++)
{
    const burgerGroup = new THREE.Group()
    const burgerSize = 0.2 * Math.random()
    burgerGroup.scale.set(burgerSize, burgerSize,burgerSize)
    const burgerSpread = 50
    burgerGroup.position.x = (Math.random() - 0.5) * burgerSpread
    burgerGroup.position.y = (Math.random() - 0.5) * burgerSpread
    burgerGroup.position.z = (Math.random() - 0.5) * burgerSpread
    scene.add(burgerGroup)

    // Meat
    const meatHeight = 0.6
    const meat = new THREE.Mesh(cylinderGeometry,meatMaterial)
    meat.scale.y = meatHeight
    burgerGroup.add(meat)

    // Bread Under
    const breadHeight = 0.3
    const breadOffset = meatHeight / 2 + breadHeight / 2 + 0.1
    const bread1 = new THREE.Mesh(cylinderGeometry,breadMaterial)
    bread1.scale.y = breadHeight
    bread1.scale.x = 0.9
    bread1.scale.z = 0.9
    bread1.position.y = - breadOffset
    burgerGroup.add(bread1)

    // Bread above
    const bread2 = new THREE.Mesh(cylinderGeometry,breadMaterial)
    bread2.scale.y = breadHeight
    bread2.scale.x = 0.9
    bread2.scale.z = 0.9
    bread2.position.y = breadOffset
    burgerGroup.add(bread2)

    // Animation
    gsap.to(burgerGroup.rotation, { duration: 15, delay: 0.1, x: Math.random() * Math.PI * 6 })
    gsap.to(burgerGroup.rotation, { duration: 15, delay: 0.1, z: Math.random() * Math.PI * 6 })
}

/**
 * Animate
 */
const clock = new THREE.Clock()
let oldElapsedTime = 0

const tick = () =>
{
    // Parameters
    const elapsedTime = clock.getElapsedTime()
    const deltaTime = elapsedTime - oldElapsedTime
    oldElapsedTime = elapsedTime

    // Update Physics World
    world.step( 1 / 60, deltaTime, 3 )
    
    for( const object of objectsToUpdate)
    {
        object.mesh.position.copy(object.body.position)
        object.mesh.quaternion.copy(object.body.quaternion)
    }

    // Update mini burgers
    // burgerGroup.rotation.x = elapsedTime

    // Update controls
    controls.update()

    // Render
    renderer.render(scene, camera)

    // Call tick again on the next frame
    window.requestAnimationFrame(tick)
}

tick()